import { CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED, MODAL_OPEN_CLASS } from '../constants';

/**
 * @type {import('../index.d').openPopup}
 */
export function openPopup(popup, closeButton) {
  popup.setAttribute('aria-hidden', 'false');
  popup.classList.add(CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED);

  if (closeButton) {
    closeButton.focus();
  }

  document.body.classList.add(MODAL_OPEN_CLASS);
}

/**
 * @type {import('../index.d').closePopup}
 */
export function closePopup(popup, notifyButton) {
  popup.setAttribute('aria-hidden', 'true');
  popup.classList.remove(CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED);
  notifyButton.focus();
  document.body.classList.remove(MODAL_OPEN_CLASS);
}
